import jwtDecode from "jwt-decode";

export class JwtToken {

    constructor(rawJson) {
        this.rawJson = rawJson;
    }

    static fromLocalStorage() {
        return new JwtToken(localStorage.getItem('access_token'));
    }

    userId() {
        const userId = this.getProperty('user_id');

        return parseInt(userId);
    }

    name() {
        const name = this.getProperty('name');

        return parseInt(name);
    }

    email() {
        const email = this.getProperty('email');

        return parseInt(email);
    }

    organizationId() {
        const orgId = this.getProperty('orgid');

        return parseInt(orgId);
    }

    isSystemAdmin() {
        const systemAdmin = this.getProperty('system_admin');

        return systemAdmin === 'true';
    }

    associations() {
        return JSON.parse(this.getProperty('roles'))
    }

    isProfileSwitcher() {

        const profileSwitcher = this.getProperty('ProfilSwitcher');

        return profileSwitcher && profileSwitcher.toLowerCase() === "true";
    }

    decoded() {
        return this.rawJson ? jwtDecode(this.rawJson) : null;
    }

    getProperty(name) {

        const token = this.decoded();

        if (token) {
            return token[name];
        }

        return null;
    }
}